import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody, ResponseBody } from '@/shared/api/generated';

type PromptLibraryPath =
  '/v1/workspaces/{workspace_id}/prompt-libraries/{prompt_library_id}';

export type UpdateHeySynclyPromptLibraryParams =
  PathParams<PromptLibraryPath, 'patch'> &
    RequestBody<PromptLibraryPath, 'patch'>;
export type UpdateHeySynclyPromptLibraryResponse = ResponseBody<
  PromptLibraryPath,
  'patch'
>;

export const updateHeySynclyPromptLibrary = ({
  workspace_id,
  prompt_library_id,
  ...body
}: UpdateHeySynclyPromptLibraryParams): Promise<UpdateHeySynclyPromptLibraryResponse> =>
  v1ApiClient
    .patch(`/workspaces/${workspace_id}/prompt-libraries/${prompt_library_id}`, body)
    .then((res) => res.data);
